import { takeFirst, takeData } from '../../../shared/misc';
import { setAppConfig } from '../model/app-config';
import { decompressValue } from './utils';

export const fetchMEventsAPI = async (coreSettings) => {
  const {
    server_addr: serverAddress,
    app_ids: appId,
    api_user_pass: authPass,
    api_user_name: authName
  } = coreSettings;

  const url = new URL(`https://${serverAddress}`);
  url.pathname = '/v1/cms_settings.json';
  url.searchParams.append('include_value', 1);
  url.searchParams.append('last_item_by_uuid', 1);
  url.searchParams.append('app_id', appId);
  url.searchParams.append('uuid', 'app_config');

  const auth = `${authName}:${authPass}`;
  const headers = {
    authorization: `Basic ${btoa(auth)}`,
    'content-type': 'application/json'
  };

  const req = new Request(url, { headers });
  return fetch(req).then(takeData).then(takeFirst).then(decompressValue)
    .then(setAppConfig);
};
